module.exports = __webpack_public_path__ + "assets/img/logo-apowersoft.d5795940.svg";